/**
 * RDV en ligne (#429) — Epic 3, endpoint géocodage public (#575).
 *
 * Contrat du body de `POST /api/pro/:slug/geocode` : l'adresse saisie par le
 * visiteur du tunnel public de réservation (#569 PR-B). Les champs sont mappés
 * 1:1 sur la signature de `fetchGeocode(zip, city, address, address2?)`
 * (`geo.service.ts`), réutilisée telle quelle côté backend.
 *
 * La réponse est le type existant `IGeocode | null` (`./geocode.model.ts`) — le
 * `score` renvoyé est BRUT ; la décision « adresse exploitable » (≥ `SCORE_LIMIT`)
 * est portée par le FE, pas par l'endpoint. Pas de nouveau type de réponse.
 */
import { z } from "zod";
import { PUBLIC_API_ADDRESS_MAX, PUBLIC_API_SHORT_STRING_MAX } from "../publicApi/bounds.js";
import { FR_ZIP_MESSAGE, FR_ZIP_REGEX } from "./frZip.js";
/** Public geocode body (#575). Anti-abuse bounds + shared FR zip format (#622). */
export const PublicGeocodePayloadSchema = z.object({
    address: z.string().max(PUBLIC_API_ADDRESS_MAX),
    zip: z.string().regex(FR_ZIP_REGEX, FR_ZIP_MESSAGE),
    city: z.string().max(PUBLIC_API_SHORT_STRING_MAX),
    address2: z.string().max(PUBLIC_API_ADDRESS_MAX).optional(),
});
//# sourceMappingURL=publicGeocode.js.map